// Central content for the FitSwag landing page (IT + EN).
// FitSwag = healthy-eating / nutrition scanner: scan food by photo, barcode or
// nutrition label and instantly get nutritional values, keep everything under
// control and get nudged to eat better.
// Legal texts are professional templates using placeholder contact details —
// have them reviewed by a lawyer before publishing.

export const CONTACT_EMAIL = "support@fitswag.it";
export const COMPANY = "FitSwag";
export const DOMAIN = "www.fitswag.it";
const UPDATED_IT = "Ultimo aggiornamento: giugno 2026";
const UPDATED_EN = "Last updated: June 2026";

// Photography (Unsplash)
export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1590779033100-9f60a05a013d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwY29sb3JmdWwlMjBmb29kJTIwZmxhdCUyMGxheSUyMGZyZXNoJTIwdmVnZXRhYmxlc3xlbnwwfHx8fDE3ODYwMzc0OTN8MA&ixlib=rb-4.1.0&q=85";
export const SCAN_IMAGE =
  "https://images.unsplash.com/photo-1544633909-3de7702b9602?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const CONTROL_IMAGE =
  "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

// Real iOS app screenshots uploaded by the user.
export const SCREEN_TODAY =
  "https://customer-assets-agu9un31.emergentagent.net/job_delay-gate-smooth/artifacts/7p90v7hz_Screenshot%202026-08-06%20alle%2019.43.57.png";
export const SCREEN_SWAG =
  "https://customer-assets-agu9un31.emergentagent.net/job_delay-gate-smooth/artifacts/dy9hfywo_Screenshot%202026-08-06%20alle%2019.44.16.png";
export const SCREEN_DIARY =
  "https://customer-assets-agu9un31.emergentagent.net/job_delay-gate-smooth/artifacts/ejymmqeh_Screenshot%202026-08-06%20alle%2019.44.45.png";
export const SCREEN_PROGRESS =
  "https://customer-assets-agu9un31.emergentagent.net/job_delay-gate-smooth/artifacts/w76iedjp_Screenshot%202026-08-06%20alle%2019.50.07.png";

// FitSwag 06 real screenshots
const A = "https://customer-assets-agu9un31.emergentagent.net/job_delay-gate-smooth/artifacts/";
export const APP_OGGI = A + "533kfo3m_IMG_4550.webp";                 // Oggi dashboard (light)
export const APP_OGGI_DARK = A + "533kfo3m_IMG_4550.webp";            // (light fallback)
export const APP_SWAG = A + "ioxzd8eb_IMG_4554.webp";                 // SwaG chat (light)
export const APP_CATALOG = A + "urk00x4s_IMG_4546.webp";             // Catalogo grid (dark)
export const APP_PIANO_LISTA = A + "1zq9nmny_IMG_4545.webp";          // Piano lista spesa (dark)
export const APP_PIANO_MENU = A + "ews646ds_IMG_4555.webp";           // Piano menu 7 giorni (light)
export const APP_DIARIO = A + "6fyhimuy_IMG_4551.webp";               // Diario (light)
export const APP_RECIPE_RICOTTA = A + "aq0qi0kk_IMG_4549.webp";        // recipe (dark)
export const APP_RECIPE_ARISTA = A + "4cwsatlu_IMG_4548.webp";         // recipe (dark)
export const APP_RECIPE_BOLLITO = A + "k9a88cqd_IMG_4547.webp";        // recipe (dark)
export const APP_RECIPE_CONTROFILETTO = A + "zbkwbpuc_IMG_4556.webp";  // recipe (light)
export const APP_PRODUCT = A + "taq289mz_IMG_4552.webp";              // product detail (light)
export const APP_ANALYSIS = A + "en761azp_IMG_4553.webp";            // health analysis (light)

// Cinematic food photography (wide)
export const FOOD_POLPETTE = A + "vhvrhrzg_image%20%285%29.jpeg";
export const FOOD_PESCE = A + "ofa93wks_image%20%287%29.jpeg";
export const FOOD_FEGATO = A + "5k10eyvc_image%20%2810%29.jpeg";
export const FOOD_BACCALA = A + "i4w9xawh_image%20%2811%29.jpeg";
export const FOOD_PASTA = A + "2zs9iw4c_image%20%2812%29.jpeg";

export const content = {
  it: {
    nav: { features: "Funzionalità", swag: "SwaG", piano: "Piano", how: "Come funziona", faq: "FAQ", privacy: "Privacy", terms: "Termini", download: "Scarica" },
    hero: {
      badge: "FitSwag 06 · Mangia sano, con gusto",
      titleLines: ["Mangia meglio.", "Senza pensieri."],
      subtitle:
        "Scansiona il cibo, scopri i valori reali e lascia che SwaG — l'AI con la battuta pronta — decida cosa cucini stasera. Anche con quello che hai già in frigo.",
      ctaPrimary: "Scarica su App Store",
      ctaSecondary: "Disponibile su Google Play",
      note: "Gratis da scaricare · iPhone e Android",
    },
    marquee: ["SWAG AI", "FOTO AI", "BARCODE", "ETICHETTE", "PIANO SETTIMANALE", "DIARIO", "PROGRESSI", "MACRO", "CALORIE", "MANGIA SANO"],
    about: {
      overline: "Cos'è FitSwag",
      title: "Mangiare sano, senza pensieri",
      paragraphs: [
        "Capire cosa c'è davvero nel tuo piatto non deve essere complicato. Con FitSwag scansioni un alimento con una foto, il codice a barre o l'etichetta e ottieni subito calorie e valori nutrizionali.",
        "E quando non sai cosa mangiare, ci pensa SWAG AI: ti suggerisce piatti sani partendo dalle tue voglie o da quello che hai in frigo — anche con abbinamenti che non avresti mai immaginato.",
      ],
    },
    features: {
      overline: "Funzionalità",
      title: "Tutto quello che ti serve per mangiare meglio",
      items: [
        { icon: "Sparkles", title: "SWAG AI", desc: "Dimmi cosa hai voglia di mangiare o cosa hai in casa: SWAG crea il piatto perfetto, anche con ingredienti che non penseresti mai di combinare." },
        { icon: "Camera", title: "Foto AI", desc: "Fotografa il piatto e ottieni subito calorie e valori nutrizionali, senza digitare nulla." },
        { icon: "Barcode", title: "Barcode", desc: "Scansiona il codice a barre di un prodotto e registra tutto in un tap." },
        { icon: "ScanLine", title: "Etichette", desc: "Fotografa l'etichetta nutrizionale: la leggiamo noi per te." },
        { icon: "CalendarDays", title: "Piano settimanale", desc: "Menu della settimana e lista della spesa generati dall'AI, su misura per i tuoi obiettivi." },
        { icon: "TrendingUp", title: "Progressi & macro", desc: "Calorie, proteine, carboidrati, grassi, peso e deficit sempre sotto controllo." },
      ],
    },
    scan: {
      overline: "Come funziona",
      title: "Scansiona il cibo in un secondo",
      paragraphs: [
        "Tre modi per registrare tutto in un attimo: inquadra il piatto con la Foto AI, leggi il barcode di un prodotto o fotografa l'etichetta nutrizionale.",
        "Niente da digitare, niente ricerche infinite: FitSwag riconosce l'alimento e calcola i valori al posto tuo.",
      ],
      cta: "Scarica FitSwag",
    },
    control: {
      overline: "SWAG AI",
      title: "Non sai cosa cucinare? Chiedi a SWAG",
      paragraphs: [
        "Dimmi cosa hai voglia di mangiare, oppure raccontami cosa hai in casa: SWAG AI crea il piatto giusto per te, sano e su misura.",
        "Il bello? Ti fa mangiare bene anche combinando ingredienti che non avresti mai pensato di mettere insieme in un piatto.",
      ],
      cta: "Scopri SWAG AI",
    },
    appScreens: {
      overline: "Anteprima",
      title: "L'app in azione",
      subtitle: "Dai un'occhiata a FitSwag: la tua giornata, SWAG AI, il diario e i progressi.",
      captions: ["Oggi", "SWAG AI", "Diario", "Progressi"],
      note: "Immagini reali dell'app.",
    },
    swag: {
      overline: "SwaG · Il tuo chef AI",
      title: "Digli cosa vuoi. Al resto pensa lui.",
      subtitle: "Scrivi o parla: SwaG capisce le tue voglie o guarda cosa hai in casa e crea il piatto giusto per te. Con la battuta sempre pronta.",
      placeholder: "Scrivi un pasto o una domanda…",
      points: [
        "Scrivi o usa la voce: «Ho fame, cosa mangio?»",
        "Parti da una voglia o da cosa hai in frigo",
        "Abbinamenti che non avresti mai osato — ma che funzionano",
      ],
      chat: [
        { role: "user", text: "Fammi una carbonara" },
        { role: "swag", text: "Oh, finalmente una richiesta seria. Mi allaccio il grembiule." },
        { role: "swag", text: "Piatto pronto: «Spaghetti alla carbonara con pancetta» — 661 kcal, 6 ingredienti. Ti ho fatto fare bella figura anche oggi." },
      ],
      cta: "Prova SwaG",
    },
    bento: {
      overline: "Le tue aree",
      title: "Tutto quello che ti serve, in un'unica app.",
      home: { title: "Home", desc: "Calorie, macro, obiettivo, acqua, passi, peso e la tua streak di costanza — in un colpo d'occhio." },
      diary: { title: "Diario", desc: "Registra a mano, con foto, barcode o etichetta. La fonte di verità di ciò che mangi davvero." },
      catalog: { title: "Catalogo", desc: "Database di piatti con ingredienti, grammature e valori completi. Cerca, sostituisci e aggiungi al piano." },
      score: { title: "Punteggio FitSwag", desc: "Voto 0–100 con Nutri-Score, additivi e soglie OMS/EFSA: punti di forza e cose da tenere d'occhio." },
    },
    piano: {
      overline: "Piano",
      title: "Un piano alimentare creato per te.",
      subtitle: "SwaG genera il tuo piano partendo dall'obiettivo, dalle calorie e dai macro — rispettando gusti, stile alimentare e allergie. Poi rigeneri tutto con un tocco.",
      goals: ["Dimagrimento", "Mantenimento", "Massa", "Definizione", "Ricomposizione"],
      tabs: [
        { title: "Menu 7 giorni", desc: "Colazione, pranzo, cena e spuntini per ogni giorno, con le calorie giuste per il tuo obiettivo." },
        { title: "Lista spesa", desc: "Tutti gli ingredienti raggruppati per reparto, con quantità e peso totale. Spunti e via." },
        { title: "Dispensa", desc: "Segna cosa hai in casa: SwaG lo usa per proporti piatti senza sprechi." },
      ],
    },
    gallery: {
      overline: "L'app in azione",
      title: "Bella da vedere. Facile da usare.",
      subtitle: "Un assaggio di FitSwag: Oggi, Diario, Piano, Catalogo e le ricette.",
      captions: ["Oggi", "Diario", "Piano", "Catalogo", "Ricetta"],
    },
    faq: {
      overline: "FAQ",
      title: "Domande frequenti",
      items: [
        { q: "FitSwag è gratis?", a: "Sì, scaricare e iniziare a usare FitSwag è gratuito. Alcune funzionalità avanzate possono essere offerte tramite abbonamento o acquisti in-app: prezzi e condizioni sono sempre mostrati prima dell'acquisto." },
        { q: "Cos'è SWAG AI?", a: "SWAG AI è il tuo assistente per mangiare sano: gli dici cosa hai voglia di mangiare o cosa hai in casa e lui crea il piatto giusto per te, anche con abbinamenti sorprendenti che non avresti mai immaginato." },
        { q: "Come funzionano gli abbonamenti?", a: "Gli abbonamenti a rinnovo automatico sono gestiti dallo store (App Store o Google Play). Puoi gestirli o disdirli in qualsiasi momento dalle impostazioni del tuo account store, almeno 24 ore prima del rinnovo." },
        { q: "Come vengono trattati i miei dati?", a: "Prendiamo la privacy sul serio: non vendiamo i tuoi dati personali e le foto vengono usate solo per riconoscere gli alimenti. Trovi tutti i dettagli nella nostra Informativa sulla Privacy." },
        { q: "Come elimino il mio account?", a: "Puoi eliminare account e dati direttamente dall'app in Impostazioni → Account → Elimina account, oppure scrivendoci a support@fitswag.it." },
        { q: "I valori nutrizionali sono accurati?", a: "I valori sono stime basate su database di terze parti e sul riconoscimento automatico e hanno scopo puramente informativo. Non sostituiscono un parere medico o dietetico: per allergie e intolleranze verifica sempre l'etichetta ufficiale del prodotto." },
      ],
    },
    download: {
      overline: "Inizia ora",
      title: "PRONTO A MANGIARE MEGLIO?",
      subtitle: "Scarica FitSwag, scansiona il cibo e lascia che SWAG AI ti guidi verso scelte più sane, ogni giorno.",
      ctaPrimary: "Scarica su App Store",
      ctaSecondary: "Disponibile su Google Play",
    },
    footer: {
      tagline: "Scansiona. Chiedi a SWAG. Mangia meglio.",
      contactTitle: "Contatti",
      links: { privacy: "Privacy", terms: "Termini", features: "Funzionalità", how: "Come funziona", faq: "FAQ", support: "Supporto" },
      rights: `© ${new Date().getFullYear()} FitSwag. Tutti i diritti riservati.`,
      madeIn: "Fatto con cura in Italia.",
    },
    support: {
      badge: "Supporto",
      title: "Supporto FitSWAG",
      intro: "Siamo qui per aiutarti. Scrivici e ti risponderemo il prima possibile.",
      contactLabel: "Contatto principale",
      topicsTitle: "Con cosa possiamo aiutarti",
      topics: [
        "Account e accesso",
        "Problemi tecnici",
        "Utilizzo di FitSWAG",
        "Privacy e dati",
        "Segnalazioni",
      ],
      faqTitle: "Domande frequenti",
      legalTitle: "Documenti",
      privacyLink: "Informativa sulla Privacy",
      termsLink: "Termini di Servizio",
    },
    legal: {
      privacy: {
        title: "Informativa sulla Privacy",
        updated: UPDATED_IT,
        intro:
          `La presente Informativa descrive come FitSwag ("noi") raccoglie, utilizza e protegge i tuoi dati personali quando usi l'app e il sito ${DOMAIN}. Usando FitSwag accetti le pratiche descritte di seguito.`,
        sections: [
          { title: "1. Titolare del trattamento", content: [{ p: `Il titolare del trattamento è ${COMPANY}. Per qualsiasi richiesta puoi scriverci a ${CONTACT_EMAIL}.` }] },
          { title: "2. Dati che raccogliamo", content: [
            { p: "Raccogliamo solo i dati necessari a farti usare l'app:" },
            { ul: [
              "Dati account: nome/username, email e password (in forma cifrata).",
              "Preferenze e obiettivi: obiettivi nutrizionali, preferenze alimentari e, se le indichi, intolleranze o allergie.",
              "Dati alimentari e nutrizionali: alimenti scansionati, pasti registrati nel diario, valori nutrizionali e cronologia.",
              "Foto: le immagini che scatti per scansionare cibo o etichette, elaborate per il riconoscimento.",
              "Dati di scansione: codici a barre letti dei prodotti.",
              "Dati tecnici e di utilizzo: modello dispositivo, sistema operativo, versione app, identificativi, indirizzo IP e statistiche d'uso.",
              "Dati sanitari opzionali: se colleghi Apple Health (es. dati nutrizionali), solo con il tuo consenso esplicito.",
            ] },
          ] },
          { title: "3. Fotocamera", content: [{ p: "L'accesso alla fotocamera viene usato esclusivamente per scansionare alimenti, codici a barre ed etichette. Le foto possono essere elaborate per riconoscere l'alimento e salvate nel tuo diario. Puoi revocare l'accesso in qualsiasi momento dalle impostazioni del dispositivo." }] },
          { title: "4. Come usiamo i dati", content: [
            { ul: [
              "Riconoscere gli alimenti e calcolarne i valori nutrizionali.",
              "Tenere aggiornati il tuo diario, i tuoi obiettivi e la cronologia.",
              "Personalizzare consigli e suggerimenti per mangiare meglio.",
              "Garantire sicurezza, prevenire abusi e frodi.",
              "Fornire assistenza e rispondere alle tue richieste.",
              "Adempiere a obblighi di legge.",
            ] },
          ] },
          { title: "5. Basi giuridiche (GDPR)", content: [{ p: "Trattiamo i tuoi dati sulla base del consenso, dell'esecuzione del contratto (fornitura del servizio), del legittimo interesse (sicurezza e miglioramento) e di obblighi legali." }] },
          { title: "6. Apple Health / HealthKit", content: [{ p: "Se colleghi Apple Health, i dati (es. nutrizione) sono usati esclusivamente per fornirti le funzionalità dell'app. Non usiamo i dati di HealthKit per pubblicità o marketing, non li condividiamo con terze parti a tali scopi e non li vendiamo. Puoi revocare l'accesso in qualsiasi momento." }] },
          { title: "7. Condivisione dei dati", content: [
            { p: "Non vendiamo i tuoi dati personali. Possiamo condividerli con:" },
            { ul: [
              "Fornitori di servizi (hosting, riconoscimento immagini, database nutrizionali, analisi) che agiscono per nostro conto.",
              "Autorità, se richiesto dalla legge o per tutelare diritti e sicurezza.",
              "Eventuali soggetti coinvolti in operazioni societarie (fusioni/acquisizioni), con adeguate garanzie.",
            ] },
          ] },
          { title: "8. Conservazione", content: [{ p: "Conserviamo i dati per il tempo necessario a fornirti il servizio e ad adempiere agli obblighi di legge. Quando elimini l'account, cancelliamo o anonimizziamo i tuoi dati entro un periodo ragionevole, salvo obblighi di conservazione." }] },
          { title: "9. I tuoi diritti", content: [
            { p: "Puoi esercitare i diritti previsti dal GDPR: accesso, rettifica, cancellazione, limitazione, portabilità e opposizione, oltre a revocare il consenso." },
            { p: `Cancellazione dell'account: puoi eliminare account e dati direttamente dall'app (Impostazioni → Account → Elimina account) oppure scrivendo a ${CONTACT_EMAIL}.` },
          ] },
          { title: "10. Minori", content: [{ p: "FitSwag non è destinato a minori di 13 anni (o dell'età minima prevista nel tuo Paese). Non raccogliamo consapevolmente dati di minori: se ritieni che sia accaduto, contattaci e provvederemo alla cancellazione." }] },
          { title: "11. Sicurezza", content: [{ p: "Adottiamo misure tecniche e organizzative adeguate (cifratura in transito, controlli d'accesso) per proteggere i tuoi dati. Nessun sistema è però sicuro al 100%." }] },
          { title: "12. Trasferimenti internazionali", content: [{ p: "I dati possono essere trattati in Paesi diversi dal tuo. In tal caso adottiamo garanzie adeguate (es. clausole contrattuali standard)." }] },
          { title: "13. Modifiche a questa Informativa", content: [{ p: "Potremmo aggiornare questa Informativa. Le modifiche rilevanti saranno comunicate tramite l'app o il sito. L'uso continuato costituisce accettazione." }] },
          { title: "14. Contatti", content: [{ p: `Per domande sulla privacy scrivi a ${CONTACT_EMAIL}.` }] },
        ],
      },
      terms: {
        title: "Termini di Servizio",
        updated: UPDATED_IT,
        intro:
          `I presenti Termini regolano l'uso dell'app e del sito FitSwag (${DOMAIN}). Creando un account o usando FitSwag accetti questi Termini. Se non li accetti, non usare il servizio.`,
        sections: [
          { title: "1. Idoneità ed età", content: [{ p: "Per usare FitSwag devi avere almeno 13 anni (o l'età minima prevista dalla legge del tuo Paese) e la capacità di stipulare un contratto vincolante." }] },
          { title: "2. Account e sicurezza", content: [{ p: "Sei responsabile della veridicità dei dati forniti e della custodia delle credenziali. Sei responsabile di tutte le attività svolte tramite il tuo account. Avvisaci subito in caso di uso non autorizzato." }] },
          { title: "3. Abbonamenti e acquisti", content: [
            { p: "Alcune funzionalità possono essere offerte tramite abbonamenti o acquisti in-app. Prezzi e condizioni sono mostrati prima dell'acquisto." },
            { p: "Gli abbonamenti a rinnovo automatico sono gestiti dallo store (Apple App Store / Google Play): il rinnovo avviene salvo disdetta almeno 24 ore prima della scadenza e puoi gestirli dalle impostazioni del tuo account store." },
          ] },
          { title: "4. Avvertenza importante su nutrizione e salute", content: [
            { p: "FitSwag fornisce stime dei valori nutrizionali a scopo puramente informativo e non costituisce consulenza medica, dietetica o nutrizionale." },
            { p: "I valori e i punteggi mostrati sono stime, possono contenere imprecisioni e non devono essere usati per gestire condizioni mediche, allergie o intolleranze. Non fare affidamento esclusivamente sull'app per le informazioni sugli allergeni: verifica sempre l'etichetta ufficiale del prodotto. Consulta un medico o un dietista qualificato, soprattutto in caso di patologie, allergie o gravidanza." },
          ] },
          { title: "5. Accuratezza dei dati", content: [{ p: "I dati nutrizionali derivano da database e fonti di terze parti e dal riconoscimento automatico: non garantiamo che siano sempre completi, corretti o aggiornati." }] },
          { title: "6. Contenuti dell'utente", content: [{ p: "Resti proprietario dei contenuti che aggiungi (es. foto e alimenti personalizzati). Concedi a FitSwag una licenza limitata a ospitare ed elaborare tali contenuti al solo fine di far funzionare il servizio." }] },
          { title: "7. Uso consentito", content: [
            { p: "Ti impegni a non:" },
            { ul: [
              "Usare il servizio per scopi illeciti o dannosi.",
              "Tentare di accedere senza autorizzazione, decompilare o interferire con l'infrastruttura.",
              "Caricare contenuti che violino diritti altrui o la legge.",
            ] },
          ] },
          { title: "8. Proprietà intellettuale", content: [{ p: "Il marchio FitSwag, il software, il design e i contenuti del servizio sono di nostra proprietà o dei nostri licenzianti e sono protetti dalle leggi vigenti." }] },
          { title: "9. Servizi di terze parti", content: [{ p: "Il servizio può integrarsi con servizi di terzi (es. database nutrizionali, Apple Health, store). L'uso di tali servizi è soggetto ai rispettivi termini." }] },
          { title: "10. Sospensione e cessazione", content: [{ p: "Possiamo sospendere o chiudere l'account in caso di violazione dei Termini. Puoi chiudere il tuo account in qualsiasi momento dall'app." }] },
          { title: "11. Esclusioni di garanzia", content: [{ p: 'Il servizio è fornito "così com\'è" e "come disponibile", senza garanzie di alcun tipo, nei limiti consentiti dalla legge.' }] },
          { title: "12. Limitazione di responsabilità", content: [{ p: "Nei limiti di legge, FitSwag non è responsabile per danni indiretti, incidentali o consequenziali derivanti dall'uso del servizio o dall'affidamento sui valori nutrizionali stimati." }] },
          { title: "13. Legge applicabile", content: [{ p: "I presenti Termini sono regolati dalla legge italiana. Per le controversie è competente il foro del luogo di residenza del consumatore, ove previsto dalla legge." }] },
          { title: "14. Termini specifici Apple", content: [
            { p: "Se scarichi l'app dall'App Store di Apple, riconosci che: (a) questi Termini sono conclusi tra te e FitSwag, non con Apple; (b) Apple non ha alcun obbligo di manutenzione o assistenza sull'app; (c) in caso di mancata conformità a garanzie applicabili, potrai richiedere ad Apple il rimborso del prezzo eventualmente pagato; (d) Apple e le sue controllate sono terzi beneficiari dei presenti Termini e possono farli valere nei tuoi confronti." },
          ] },
          { title: "15. Modifiche ai Termini", content: [{ p: "Potremmo aggiornare i Termini. Le modifiche rilevanti saranno comunicate tramite l'app o il sito. L'uso continuato costituisce accettazione." }] },
          { title: "16. Contatti", content: [{ p: `Per domande sui Termini scrivi a ${CONTACT_EMAIL}.` }] },
        ],
      },
    },
  },

  en: {
    nav: { features: "Features", swag: "SwaG", piano: "Piano", how: "How it works", faq: "FAQ", privacy: "Privacy", terms: "Terms", download: "Download" },
    hero: {
      badge: "FitSwag 06 · Eat well, enjoy it",
      titleLines: ["Eat better.", "Effortlessly."],
      subtitle:
        "Scan your food, see the real nutrition, and let SwaG — the AI with attitude — decide what you cook tonight. Even with whatever's already in your fridge.",
      ctaPrimary: "Download on the App Store",
      ctaSecondary: "Get it on Google Play",
      note: "Free to download · iPhone and Android",
    },
    marquee: ["SWAG AI", "PHOTO AI", "BARCODE", "LABELS", "WEEKLY PLAN", "DIARY", "PROGRESS", "MACROS", "CALORIES", "EAT HEALTHY"],
    about: {
      overline: "What is FitSwag",
      title: "Eating well, made effortless",
      paragraphs: [
        "Understanding what's really on your plate shouldn't be complicated. With FitSwag you scan a food with a photo, its barcode or its label and instantly get calories and nutritional values.",
        "And when you don't know what to eat, SWAG AI has your back: it suggests healthy dishes based on your cravings or on what's in your fridge — even with pairings you'd never have imagined.",
      ],
    },
    features: {
      overline: "Features",
      title: "Everything you need to eat better",
      items: [
        { icon: "Sparkles", title: "SWAG AI", desc: "Tell it what you feel like eating or what you have at home: SWAG builds the perfect dish, even with ingredients you'd never think to combine." },
        { icon: "Camera", title: "Photo AI", desc: "Snap your plate and instantly get calories and nutritional values — nothing to type." },
        { icon: "Barcode", title: "Barcode", desc: "Scan a product's barcode and log everything in a single tap." },
        { icon: "ScanLine", title: "Labels", desc: "Snap the nutrition label — we read it for you." },
        { icon: "CalendarDays", title: "Weekly plan", desc: "AI-generated weekly menu and shopping list, tailored to your goals." },
        { icon: "TrendingUp", title: "Progress & macros", desc: "Calories, protein, carbs, fat, weight and deficit always under control." },
      ],
    },
    scan: {
      overline: "How it works",
      title: "Scan your food in a second",
      paragraphs: [
        "Three ways to log everything in an instant: point at your plate with Photo AI, read a product's barcode, or snap the nutrition label.",
        "Nothing to type, no endless searching: FitSwag recognizes the food and computes the values for you.",
      ],
      cta: "Download FitSwag",
    },
    control: {
      overline: "SWAG AI",
      title: "Don't know what to cook? Ask SWAG",
      paragraphs: [
        "Tell it what you feel like eating, or tell it what you have at home: SWAG AI builds the right dish for you — healthy and tailored.",
        "The best part? It helps you eat well even by combining ingredients you'd never have thought to put together on a plate.",
      ],
      cta: "Discover SWAG AI",
    },
    appScreens: {
      overline: "Preview",
      title: "The app in action",
      subtitle: "Take a look at FitSwag: your day, SWAG AI, the diary and your progress.",
      captions: ["Today", "SWAG AI", "Diary", "Progress"],
      note: "Real app screenshots.",
    },
    swag: {
      overline: "SwaG · Your AI chef",
      title: "Tell it what you want. It handles the rest.",
      subtitle: "Type or talk: SwaG reads your cravings or checks what you have at home and builds the right dish for you. With a sharp comeback, always.",
      placeholder: "Type a meal or a question…",
      points: [
        "Type or use your voice: “I'm hungry, what do I eat?”",
        "Start from a craving or from what's in your fridge",
        "Pairings you'd never have dared — that somehow work",
      ],
      chat: [
        { role: "user", text: "Make me a carbonara" },
        { role: "swag", text: "Oh, finally a serious request. Let me tie my apron." },
        { role: "swag", text: "Dish ready: “Spaghetti carbonara with pancetta” — 661 kcal, 6 ingredients. Made you look good again today." },
      ],
      cta: "Try SwaG",
    },
    bento: {
      overline: "Your areas",
      title: "Everything you need, in a single app.",
      home: { title: "Home", desc: "Calories, macros, goal, water, steps, weight and your consistency streak — at a glance." },
      diary: { title: "Diary", desc: "Log by hand, with a photo, a barcode or a label. The source of truth of what you really eat." },
      catalog: { title: "Catalog", desc: "A dish database with ingredients, grams and full nutrition. Search, swap and add to your plan." },
      score: { title: "FitSwag Score", desc: "A 0–100 score with Nutri-Score, additives and WHO/EFSA thresholds: strengths and things to watch." },
    },
    piano: {
      overline: "Plan",
      title: "A meal plan built for you.",
      subtitle: "SwaG generates your plan from your goal, calories and macros — respecting your tastes, eating style and allergies. Then regenerate it all with one tap.",
      goals: ["Weight loss", "Maintenance", "Muscle gain", "Cutting", "Recomposition"],
      tabs: [
        { title: "7-day menu", desc: "Breakfast, lunch, dinner and snacks for every day, with the right calories for your goal." },
        { title: "Shopping list", desc: "Every ingredient grouped by aisle, with amounts and total weight. Check and go." },
        { title: "Pantry", desc: "Mark what you have at home: SwaG uses it to suggest dishes with zero waste." },
      ],
    },
    gallery: {
      overline: "The app in action",
      title: "Beautiful to look at. Easy to use.",
      subtitle: "A taste of FitSwag: Today, Diary, Plan, Catalog and recipes.",
      captions: ["Today", "Diary", "Plan", "Catalog", "Recipe"],
    },
    faq: {
      overline: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "Is FitSwag free?", a: "Yes, downloading and getting started with FitSwag is free. Some advanced features may be offered via subscription or in-app purchases: prices and terms are always shown before purchase." },
        { q: "What is SWAG AI?", a: "SWAG AI is your healthy-eating assistant: tell it what you feel like eating or what you have at home and it builds the right dish for you, even with surprising pairings you'd never have imagined." },
        { q: "How do subscriptions work?", a: "Auto-renewable subscriptions are managed by the store (App Store or Google Play). You can manage or cancel them at any time in your store account settings, at least 24 hours before renewal." },
        { q: "How is my data handled?", a: "We take privacy seriously: we do not sell your personal data and photos are used only to recognize foods. You'll find all the details in our Privacy Policy." },
        { q: "How do I delete my account?", a: "You can delete your account and data directly in the app under Settings → Account → Delete account, or by emailing us at support@fitswag.it." },
        { q: "Are the nutritional values accurate?", a: "The values are estimates based on third-party databases and automatic recognition and are for informational purposes only. They are not a substitute for medical or dietary advice: for allergies and intolerances always check the product's official label." },
      ],
    },
    download: {
      overline: "Get started",
      title: "READY TO EAT BETTER?",
      subtitle: "Download FitSwag, scan your food and let SWAG AI guide you toward healthier choices, every day.",
      ctaPrimary: "Download on the App Store",
      ctaSecondary: "Get it on Google Play",
    },
    footer: {
      tagline: "Scan. Ask SWAG. Eat better.",
      contactTitle: "Contact",
      links: { privacy: "Privacy", terms: "Terms", features: "Features", how: "How it works", faq: "FAQ", support: "Support" },
      rights: `© ${new Date().getFullYear()} FitSwag. All rights reserved.`,
      madeIn: "Crafted with care in Italy.",
    },
    support: {
      badge: "Support",
      title: "FitSWAG Support",
      intro: "We're here to help. Send us a message and we'll get back to you as soon as possible.",
      contactLabel: "Main contact",
      topicsTitle: "What we can help you with",
      topics: [
        "Account and sign-in",
        "Technical issues",
        "Using FitSWAG",
        "Privacy and data",
        "Reports",
      ],
      faqTitle: "Frequently asked questions",
      legalTitle: "Documents",
      privacyLink: "Privacy Policy",
      termsLink: "Terms of Service",
    },
    legal: {
      privacy: {
        title: "Privacy Policy",
        updated: UPDATED_EN,
        intro:
          `This Privacy Policy explains how FitSwag ("we") collects, uses and protects your personal data when you use the app and the website ${DOMAIN}. By using FitSwag you agree to the practices described below.`,
        sections: [
          { title: "1. Data Controller", content: [{ p: `The data controller is ${COMPANY}. For any request you can contact us at ${CONTACT_EMAIL}.` }] },
          { title: "2. Data we collect", content: [
            { p: "We only collect the data needed to run the app:" },
            { ul: [
              "Account data: name/username, email and password (stored encrypted).",
              "Preferences & goals: nutritional goals, food preferences and, if you provide them, intolerances or allergies.",
              "Food & nutrition data: scanned foods, meals logged in the diary, nutritional values and history.",
              "Photos: the images you capture to scan food or labels, processed for recognition.",
              "Scan data: product barcodes you scan.",
              "Technical & usage data: device model, OS, app version, identifiers, IP address and usage statistics.",
              "Optional health data: only if you connect Apple Health (e.g. nutrition data), with your explicit consent.",
            ] },
          ] },
          { title: "3. Camera", content: [{ p: "Camera access is used solely to scan foods, barcodes and labels. Photos may be processed to recognize the food and saved to your diary. You can revoke access at any time in your device settings." }] },
          { title: "4. How we use data", content: [
            { ul: [
              "Recognize foods and compute their nutritional values.",
              "Keep your diary, goals and history up to date.",
              "Personalize tips and suggestions to help you eat better.",
              "Ensure security and prevent abuse and fraud.",
              "Provide support and respond to your requests.",
              "Comply with legal obligations.",
            ] },
          ] },
          { title: "5. Legal bases (GDPR)", content: [{ p: "We process your data based on consent, performance of a contract (providing the service), legitimate interest (security and improvement) and legal obligations." }] },
          { title: "6. Apple Health / HealthKit", content: [{ p: "If you connect Apple Health, data (e.g. nutrition) is used solely to provide app features. We do not use HealthKit data for advertising or marketing, we do not share it with third parties for such purposes and we do not sell it. You can revoke access at any time." }] },
          { title: "7. Data sharing", content: [
            { p: "We do not sell your personal data. We may share it with:" },
            { ul: [
              "Service providers (hosting, image recognition, nutrition databases, analytics) acting on our behalf.",
              "Authorities, where required by law or to protect rights and safety.",
              "Parties involved in corporate transactions (mergers/acquisitions), with appropriate safeguards.",
            ] },
          ] },
          { title: "8. Retention", content: [{ p: "We keep data for as long as needed to provide the service and to comply with legal obligations. When you delete your account, we delete or anonymize your data within a reasonable period, unless retention is legally required." }] },
          { title: "9. Your rights", content: [
            { p: "You can exercise your GDPR rights: access, rectification, erasure, restriction, portability and objection, as well as withdrawing consent." },
            { p: `Account deletion: you can delete your account and data directly in the app (Settings → Account → Delete account) or by emailing ${CONTACT_EMAIL}.` },
          ] },
          { title: "10. Children", content: [{ p: "FitSwag is not intended for children under 13 (or the minimum age in your country). We do not knowingly collect children's data; if you believe we have, contact us and we will delete it." }] },
          { title: "11. Security", content: [{ p: "We use appropriate technical and organizational measures (encryption in transit, access controls) to protect your data. However, no system is 100% secure." }] },
          { title: "12. International transfers", content: [{ p: "Data may be processed in countries other than yours. In such cases we apply appropriate safeguards (e.g. standard contractual clauses)." }] },
          { title: "13. Changes to this Policy", content: [{ p: "We may update this Policy. Material changes will be communicated via the app or website. Continued use constitutes acceptance of the updated version." }] },
          { title: "14. Contact", content: [{ p: `For privacy questions email ${CONTACT_EMAIL}.` }] },
        ],
      },
      terms: {
        title: "Terms of Service",
        updated: UPDATED_EN,
        intro:
          `These Terms govern your use of the FitSwag app and website (${DOMAIN}). By creating an account or using FitSwag you accept these Terms. If you do not accept them, do not use the service.`,
        sections: [
          { title: "1. Eligibility & age", content: [{ p: "To use FitSwag you must be at least 13 years old (or the minimum age required by your country's law) and able to form a binding contract." }] },
          { title: "2. Accounts & security", content: [{ p: "You are responsible for the accuracy of the information you provide and for keeping your credentials safe. You are responsible for all activity under your account. Notify us immediately of any unauthorized use." }] },
          { title: "3. Subscriptions & purchases", content: [
            { p: "Some features may be offered via subscriptions or in-app purchases. Prices and terms are shown before purchase." },
            { p: "Auto-renewable subscriptions are managed by the store (Apple App Store / Google Play): they renew unless cancelled at least 24 hours before the end of the period, and you can manage them in your store account settings." },
          ] },
          { title: "4. Important nutrition & health disclaimer", content: [
            { p: "FitSwag provides estimated nutritional values for informational purposes only and does not constitute medical, dietary or nutritional advice." },
            { p: "The values and scores shown are estimates, may contain inaccuracies and must not be used to manage medical conditions, allergies or intolerances. Do not rely solely on the app for allergen information — always check the product's official label. Consult a qualified physician or dietitian, especially in case of illness, allergies or pregnancy." },
          ] },
          { title: "5. Data accuracy", content: [{ p: "Nutritional data is derived from third-party databases and sources and from automatic recognition: we do not guarantee it is always complete, correct or up to date." }] },
          { title: "6. User content", content: [{ p: "You retain ownership of the content you add (e.g. photos and custom foods). You grant FitSwag a limited license to host and process that content solely to operate the service." }] },
          { title: "7. Acceptable use", content: [
            { p: "You agree not to:" },
            { ul: [
              "Use the service for illegal or harmful purposes.",
              "Attempt unauthorized access, reverse engineer or interfere with our infrastructure.",
              "Upload content that infringes others' rights or the law.",
            ] },
          ] },
          { title: "8. Intellectual property", content: [{ p: "The FitSwag brand, software, design and service content are owned by us or our licensors and are protected by applicable laws." }] },
          { title: "9. Third-party services", content: [{ p: "The service may integrate with third-party services (e.g. nutrition databases, Apple Health, app stores). Use of those services is subject to their own terms." }] },
          { title: "10. Suspension & termination", content: [{ p: "We may suspend or terminate accounts that violate these Terms. You can close your account at any time from the app." }] },
          { title: "11. Disclaimers", content: [{ p: 'The service is provided "as is" and "as available", without warranties of any kind, to the extent permitted by law.' }] },
          { title: "12. Limitation of liability", content: [{ p: "To the extent permitted by law, FitSwag is not liable for indirect, incidental or consequential damages arising from use of the service or reliance on the estimated nutritional values." }] },
          { title: "13. Governing law", content: [{ p: "These Terms are governed by Italian law. Where mandatory consumer protection applies, the courts of the consumer's place of residence shall have jurisdiction." }] },
          { title: "14. Apple-specific terms", content: [
            { p: "If you download the app from Apple's App Store, you acknowledge that: (a) these Terms are between you and FitSwag, not Apple; (b) Apple has no obligation to provide maintenance or support for the app; (c) in case of failure to conform to any applicable warranty, you may notify Apple for a refund of the purchase price, if any; (d) Apple and its subsidiaries are third-party beneficiaries of these Terms and may enforce them against you." },
          ] },
          { title: "15. Changes to the Terms", content: [{ p: "We may update these Terms. Material changes will be communicated via the app or website. Continued use constitutes acceptance." }] },
          { title: "16. Contact", content: [{ p: `For questions about the Terms email ${CONTACT_EMAIL}.` }] },
        ],
      },
    },
  },
};
